const consoleInitialize = () => {
  if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
  }

  // Orijinal fonksiyonları sakla
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  // Filtrelemek istediğin prefix'ler
  const ignoredPrefixes = [
    "* This is an evaluation only version, it is not licensed",
    "**********",
    "* All AG Grid Enterpr",
    "* If you want to hide the watermark",
    "AG Grid: unable to find bean reference f",
    "AG Grid: Grid API"
  ];

  // Yardımcı fonksiyon
  function shouldIgnore(message) {
    return ignoredPrefixes.some(
      (prefix) => typeof message === "string" && message.startsWith(prefix)
    );
  }

  // console.error override
  console.error = function (...args) {
    if (!shouldIgnore(args[0])) {
      originalConsoleError.apply(console, args);
    }
  };

  // console.warn override
  console.warn = function (...args) {
    if (!shouldIgnore(args[0])) {
      originalConsoleWarn.apply(console, args);
    }
  };
};

export default consoleInitialize;
